import { render, staticRenderFns } from "./OnboardingGroupList.vue?vue&type=template&id=1f3b8a42"
import script from "./OnboardingGroupList.js?vue&type=script&lang=js&external"
export * from "./OnboardingGroupList.js?vue&type=script&lang=js&external"
import style0 from "./OnboardingGroupList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports